/**
 * Shared legend item components
 */

import React from 'react';
import {
  IntervalItem,
  IntervalWithValueItem,
  LegendConfig,
  LegendType,
  TextItem,
} from '@ais-ui/websockets';
import { getIntervalText, getValueText, unitToText } from './legendUtils';

interface ItemIntervalWithValueProps {
  legend: LegendConfig<LegendType>;
  item: IntervalWithValueItem;
}

interface ItemIntervalProps {
  legend: LegendConfig<LegendType>;
  item: IntervalItem;
  showBorder?: boolean;
}

interface ItemTextProps {
  item: TextItem;
}

export const ItemIntervalWithValue: React.FC<ItemIntervalWithValueProps> = ({ legend, item }) => (
  <div className="flex w-fit min-w-[140px] space-x-3 items-center">
    <div
      className="rounded-sm border h-4 w-4 shrink-0 border-border"
      style={{ backgroundColor: item.color }}
    />
    <div className="flex justify-between space-x-3 text-xs">
      <span>{getIntervalText(item)}</span>
      <span className="text-muted-foreground">
        {getValueText(item)} {unitToText(legend.unit)}
      </span>
    </div>
  </div>
);

export const ItemInterval: React.FC<ItemIntervalProps> = ({ legend, item, showBorder = true }) => (
  <div className="flex w-fit min-w-[100px] space-x-3 items-center">
    <div
      className={`rounded-sm h-4 w-4 shrink-0 ${showBorder ? 'border border-border' : ''}`}
      style={{ backgroundColor: item.color }}
    />
    <span className="text-xs">
      {getIntervalText(item)} {unitToText(legend.unit)}
    </span>
  </div>
);

export const ItemText: React.FC<ItemTextProps> = ({ item }) => (
  <div className="flex w-fit min-w-[100px] space-x-3 items-center">
    <div
      className="rounded-sm border h-4 w-4 shrink-0 border-border"
      style={{ backgroundColor: item.color }}
    />
    <span className="text-xs">{item.text}</span>
  </div>
);
